import { USER_ENDPOINTS } from "./endpoints";
import type { UpdateProfilePayload, UpdateProfileResponse } from "./types";
import { apiPatchWithData } from "../shared";

export default async function updateProfile(payload: UpdateProfilePayload): Promise<UpdateProfileResponse["data"]> {
  return apiPatchWithData<UpdateProfileResponse["data"]>(USER_ENDPOINTS.PROFILE, payload);
}
